import React, { useState, useMemo } from 'react'
import Delivery from './components/Delivery'
import messages from "./messages"
import { FormattedMessage } from 'react-intl'

const OrderDeliveries = ({ order, fetchedEvents, onRefetch }) => {
  const [events, setEvents] = useState(fetchedEvents ?? null)

  const deliveryEvents = (events || []).filter(({ type }) => type == "Delivery")

  const sortedEvents = useMemo(() => {
    return (deliveryEvents || [])
      .sort((a, b) => b.timestamp - a.timestamp) // DESC sort
      .map(({ type, ...props }, i) => {
        const Component = Delivery
        return (
          <Component
            key={`item-${i}`}
            last={i === deliveryEvents.length - 1}
            orderId={order.uid}
            onRefetch={onRefetch}
            {...props}
          />
        )
      })
  }, [events, order])

  return (
    <div className="w-full h-full flex flex-col">
      <div className="shadow bg-gray-50 w-full px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium text-gray-600 uppercase tracking-wider flex justify-between items-center">
        <span>
          <span> <FormattedMessage {...messages.deliveries}/> </span>
        </span>
      </div>

      <div className="grow overflow-y-scroll flow-root">
        <ul className="-mb-8 p-4">
          { sortedEvents }
        </ul>
      </div>
    </div>
  )
}

export default OrderDeliveries
